module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-239.2391b01d.svg";